import axiosInstance from "./axios";

export class CursoService {
    getCursos() {
        return axiosInstance
            .get("/curso")
            .then((res) => res.data)
    }

    addCurso(dto) {
        return axiosInstance
            .post("/curso", dto)
            .then((res) => res.data)
    }

    updateCurso(dto) {
        return axiosInstance
            .put(`/curso/${dto._id}`, dto)
            .then((res) => res.data)
    }

    deleteCurso(id) {
        return axiosInstance
            .delete(`/curso/${id}`)
            .then((res) => res.data)
    }

    // El contenido (temas/subtemas) suele estar relacionado con el curso
    getContenidoPorCurso(cursoId) {
        return axiosInstance
            .get(`/contenido`, { params: { curso: cursoId } })
            .then((res) => res.data)
    }
}
